import { frontendURL } from 'dashboard/helper/URLHelper.js';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

import AudiencesRouteView from './pages/AudiencesRouteView.vue';
import AudiencesIndexPage from './pages/AudiencesIndexPage.vue';

const audiencesRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/campaigns/whatsapp/audiences'),
      component: AudiencesRouteView,
      children: [
        {
          path: '',
          name: 'audiences_index',
          component: AudiencesIndexPage,
          meta: {
            permissions: ['administrator'],
            featureFlag: FEATURE_FLAGS.WHATSAPP_CAMPAIGNS,
          },
        },
      ],
    },
  ],
};

export default audiencesRoutes;
